import apiService from '../apiService'

const apiPath = '/comission'

export const comissionController = (configService) => {
	const service = apiService(configService)
	return {
		getIncentiveShoptro: (params) => {
			return service.post({
				url: `${apiPath}/get_incentive_shoptro`,
				body: { ...params },
			})
		},
		getComDetail: (quo_num) => {
			return service.get({
				url: `${apiPath}/get_com_detail?quo_num=${quo_num}`,
			})
		},
		getAllCommissionRate: () => {
			return service.get({
				url: `${apiPath}/get_all_commission_rate`,
			})
		},
		getUserCommissionRate: () => {
			return service.get({
				url: `${apiPath}/get_user_commission_rate`,
			})
		},
		getUserProvinceCommissionRate: () => {
			return service.get({
				url: `${apiPath}/get_user_province_commission_rate`,
			})
		},
	}
}
